module.exports = require("platformEvents");;